import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '/src/store'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   // component: Home
  //   component: () => import(/* webpackChunkName: "home" */ '../views/shift-page.vue')
  // },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/CashHome.vue')
  },
  // // todo move to view
  {
    path: '/order',
    component: () => import('../components/order/ClientIdentify.vue'),
    alias: '/order/new'
  },
  // // todo move to view
  {
    path: '/order/clientcard',
    component: () => import('../components/order/ClientCard.vue'),
    alias: '/client-card'
  },
  {
    path: '/order/chooseservices',
    component: () => import('../components/order/ChooseServices/ChooseServices.vue'),
    alias: '/choose-services'
  },
  {
    path: '/order/:orderId',
    component: () => import('../views/NewOrder.vue')
  },
  {
    path: '/shift',
    component: () => import('../views/shift-page.vue')
  },
  {
    path: '/newclient',
    component: () => import('../components/order/NewClient.vue')
  },
  {
    path: '/newclient/from-queue',
    component: () => import('../components/order/NewClient.vue'),
    props: { queue: true }
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.state.login.isAuth && to.fullPath !== '/login') {
    store.dispatch('login/checkAuth').then(() => {
      next()
    }).catch(() => {
      next('/login')
    })
  } else {
    next()
  }
})

export default router
